var _path, _path2, _path3;
import { createTablerIcon } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createTablerIcon({
  Content() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [_path || (_path = /*#__PURE__*/_jsx("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
        d: "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
      })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
        d: "M7 12h14l-3 -3m0 6l3 -3"
      }))]
    });
  },
  name: 'logout'
});